import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import Colors from "../utils/Colors";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            isLoading: false,
            error: "",
            sucess:false,
        }
    }

    OnForgotPassword = async () => {
        if(this.state.isLoading || this.state.sucess)
            return

        this.setState({isLoading: true})
        try{
            if(!this.state.email){
                this.setState({error:"Should not be empty", isLoading: false})
            }else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)){
                this.setState({error:"Invalid email address", isLoading: false})
            }else{
                await Fire.shared.recoverEmail(this.state.email).then((didRecover) => {
                    if(didRecover){
                        // Alert.alert("We've sucessfully sent your password reset link to your email")
                        this.setState({sucess:true})
                    }else{
                        this.setState({error:"An error occurred", isLoading: false})
                    }
                })
                this.setState({isLoading:false})
            }
            
        }catch(error){
            this.setState({error:"An error occurred", isLoading: false})
        }
    }

    goBack = () => {
        try {
            this.props.history.goBack();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {
        const error = this.state.error;
        
        return (
            <div style={{width:"100%"}}>
                <section className="container">
                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center", marginBottom:40 }} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Forgot your password?</h2>
                    </div>
                    {/* <span>Did you forgot your password?  </span> */}
                    <div style={{margin:"20px 0"}}>
                        <span style={{color:"#777"}}>Enter your email adress you're using for your account below and we will send you a password reset link</span>
                    </div>
                    <div>
                        <SucessMessage isSucess={this.state.sucess} text="We've sucessfully sent you a recovery email"></SucessMessage>
                        <ErrorMessage text={error}></ErrorMessage>
                        <TextInputMaterial type="text" placeholder="Email" 
                            onChange={(e) => {
                                this.setState({ email: e.target.value });
                            }}/>
                        <ButtonLoader 
                            text="Send Recover Email" 
                            loading={this.state.isLoading} 
                            style={{backgroundColor: Colors.mainColor, width:"100%", height: 45, marginTop:20}}
                            // icon={FacebookIcon}
                            onClick={this.OnForgotPassword}
                        ></ButtonLoader>
                    </div>

                </section>
            </div>
        );
    }
}

export default ForgotPassword;